import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './AdminHeader.css';

const AdminHeader = ({ title, onBack, showBackButton = false }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="admin-header">
      <div className="header-content">
        <div className="header-left">
          {showBackButton && (
            <button onClick={onBack} className="back-btn">
              ← Back to Dashboard
            </button>
          )}
          <h1>{title}</h1>
        </div>
        
        <div className="header-right">
          <div className="user-info">
            <span className="user-greeting">Welcome, {user?.username}</span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
